import ax from '../api.js'

class StripeService {
	static async getAvailablePlans() {
		const { data } = await ax.get('/features/stripe/plans.php')
		return data
	}

	static async searchCustomers(email, country = null) {
		if (!email) return
		const { data } = await ax.post(
			'/features/stripe/search-customers.php',
			{
				email,
				country
			}
		)
		return data
	}

	static async createCustomer(email, country = null) {
		const { data } = await ax.post('/features/stripe/create-customer.php', {
			email,
			country
		})
		return data
	}

	static async getCustomerIdByEmail(email, country = null) {
		let customerId = null

		const response = await this.searchCustomers(email, country)
		if (response.status === 'not_found') {
			const createCustomerResponse = await this.createCustomer(
				email,
				country
			)
			if (!createCustomerResponse?.id) {
				console.log('createCustomerResponse', createCustomerResponse)
				throw new Error(`Failed to create new customer: ${email}`)
			}
			customerId = createCustomerResponse.id
		} else if (response.status === 'success') {
			customerId = response.customer.id
		}

		if (!customerId) {
			throw new Error(`Customer ID not found for email: ${email}`)
		}

		// Validate the customerId format
		if (!/^cus_[a-zA-Z0-9]+$/.test(customerId)) {
			throw new Error(`Invalid Customer ID format: ${customerId}`)
		}

		return customerId
	}

	static async getSubscriptionStatus(email) {
		const customerId = await this.getCustomerIdByEmail(email)
		const { data } = await ax.post(
			'/features/stripe/subscription-status.php',
			{ customerId }
		)
		return data
	}

	static async createCheckoutSession({ email, priceId, category }) {
		const customerId = await this.getCustomerIdByEmail(email)
		const { data } = await ax.post(
			'/features/stripe/checkout-session.php',
			{ customerId, email, priceId, category }
		)
		return data
	}

	static async cancelSubscription(email, payload) {
		const customerId = await this.getCustomerIdByEmail(email)
		const { data } = await ax.post(
			'/features/stripe/cancel-subscription.php',
			{ customerId, ...payload }
		)
		return data
	}

	static async stripeManagementImportEuropeProductsIntoUsa() {
		console.log('Importing Europe products into USA')
		const { data } = await ax.post(
			'/features/stripe/management/import-products.php'
		)
		return data
	}

	static async stripeManagementImportUsaProductsIntoEurope() {
		console.log('Importing Usa products into Europe')
		const { data } = await ax.post(
			'/features/stripe/management/import-products-from-us.php'
		)
		return data
	}

	static async stripeManagementProductList() {
		console.log('Importing Europe products into USA')
		const { data } = await ax.post(
			'/features/stripe/management/product-list.php'
		)
		return data
	}

	static async stripeProductsSync() {
		console.log('Syncing products with Stripe')
		await ax.post(
			'/features/stripe/products-sync/add-products-from-json.php'
		)
	}
	static async stripeProductsSyncMeta() {
		console.log('Syncing products with Stripe')
		await ax.post('/features/stripe/products-sync/product-meta-update.php')
	}

	static async stripeManagementUpdateProductSubMeta() {
		console.log('Setup missing subcategories on products')
		const { data } = await ax.post(
			'/features/stripe/management/updateProductSubMeta.php'
		)
		return data
	}

	static async stripeManagementGrowPrices() {
		const { data } = await ax.post(
			'/features/stripe/management/grow-prices.php?pct=25'
		)
		return data
	}

	static async resumeSubscription(email, payload = {}) {
		const customerId = await this.getCustomerIdByEmail(email)
		const { data } = await ax.post(
			'/features/stripe/resume-subscription.php',
			{ customerId, ...payload }
		)
		return data
	}

	static async successHandler(payload = {}) {
		const { data } = await ax.post('/features/stripe/success-handler.php', {
			...payload
		})
		return data
	}

	/**
	 *
	 * @param {*} user - Class User instance
	 * @returns
	 */
	static async newPromoCodeForUser(user) {
		// Step 1: Get the customer ID by email (also creates a new customer if not found)
		const customerIdEu = await this.getCustomerIdByEmail(
			user.email,
			'RO' // Force Romania for promo code creation
		)
		const customerIdUs = await this.getCustomerIdByEmail(
			user.email,
			'US' // Force Us for promo code creation helper
		)

		// Step 2: Create a new promo code for the customer
		const { data } = await ax.post(
			'/features/stripe/new-seller-promo-code.php',
			{
				customerName: user.name,
				customerIdEu,
				customerIdUs
			}
		)
		return data
	}
}

export default StripeService
